"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var VoiceTeacher1_exports = {};
__export(VoiceTeacher1_exports, {
  default: () => VoiceTeacher1_default
});
module.exports = __toCommonJS(VoiceTeacher1_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.14062 13.7266C6.6849 13.2839 6.32682 12.763 6.06641 12.1641C5.80599 11.5651 5.67578 10.9271 5.67578 10.25C5.67578 9.58594 5.79948 8.96094 6.04688 8.375C6.29427 7.78906 6.63932 7.27474 7.08203 6.83203C7.52474 6.38932 8.03906 6.04427 8.625 5.79688C9.21094 5.54948 9.83594 5.42578 10.5 5.42578C11.1771 5.42578 11.8151 5.55599 12.4141 5.81641C13.013 6.07682 13.5339 6.4349 13.9766 6.89062L7.14062 13.7266ZM14.6797 6.1875C14.1458 5.64062 13.5208 5.21094 12.8047 4.89844C12.0885 4.57292 11.3203 4.41016 10.5 4.41016C9.69271 4.41016 8.9375 4.56641 8.23438 4.87891C7.51823 5.17839 6.89323 5.59505 6.35938 6.12891C5.83854 6.64974 5.42839 7.26823 5.12891 7.98438C4.81641 8.6875 4.66016 9.44271 4.66016 10.25C4.66016 11.0703 4.81641 11.8385 5.12891 12.5547C5.45443 13.2708 5.89062 13.8958 6.4375 14.4297C6.95833 14.9375 7.5638 15.3411 8.25391 15.6406C8.95703 15.9401 9.70573 16.0898 10.5 16.0898C11.3073 16.0898 12.0625 15.9336 12.7656 15.6211C13.4818 15.3216 14.1003 14.9115 14.6211 14.3906C15.1549 13.8568 15.5716 13.2318 15.8711 12.5156C16.1836 11.8125 16.3398 11.0573 16.3398 10.25C16.3398 9.54688 16.2161 8.88281 15.9688 8.25781C15.7344 7.61979 15.4089 7.04688 14.9922 6.53906C14.9531 6.47396 14.901 6.41536 14.8359 6.36328C14.7839 6.29818 14.7318 6.23958 14.6797 6.1875Z",
      fill: "currentColor"
    }
  )
);
const SvgVoiceTeacher1 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var VoiceTeacher1_default = SvgVoiceTeacher1;
